<template>
    <v-card style="padding-left:0.16rem;margin-bottom:10px" @click="goDetail" v-bind="$attrs">
      <v-list three-line subheader style="padding-bottom:0;" >
        <v-list-item style="min-height:54px;padding:0 8px;">
          <v-list-item-content style="padding:8;">
            <v-list-item-title style="min-height:1.6rem;">
               <span style="text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:100%;color:#616161;font-size:1.0rem;display:inline-block;font-weight: 600;padding-right: 40px;">
                  <v-icon
                    style="background: #1769aa;
                      border-radius: 50%;
                      color: #ffffff;
                      font-size: 16px;
                      width: 24px;
                      height: 24px;
                      margin-right: 6px">
                      mdi-domain
                  </v-icon>
                    {{orderInfo.company_name}}
                  </span>
                  <i class="fa fa-angle-right" style="margin-left: -16px;font-size: 22px;color:#9e9e9e;" aria-hidden="true"></i>
              <v-divider style="margin: 10px 0;"></v-divider>
              <v-row no-gutters style="width:100%;">
                <v-col :cols="2" style="text-align:left;padding-left:0.06rem;">
                  <PriorityLabel :value="orderInfo.GZ_PRIORITY" />
                </v-col>
                <v-col :cols="8">
                  <span style="text-overflow:ellipsis;overflow:hidden;white-space:nowrap;width:100%;color:#616161;font-size:0.95rem;display:inline-block;padding-top:0.2rem;">
                    {{orderInfo.GZ_TITLE}}
                  </span>
                </v-col>
                <v-col :cols="2" style="text-align:right;padding-top:0.101rem;padding-right:0.3rem;">
                  <span style="font-size:0.78rem;">
                    <GzBizSidLabel :value="orderInfo.BIZ_SID" />
                  </span>
                </v-col>
              </v-row>
            </v-list-item-title>
            <v-list-item-subtitle style="margin-top:0.2rem;">
              <v-row no-gutters style="width:100%;">
                <v-col :cols="2" style="text-align:left;padding-left:0.06rem;">
                </v-col>
                <v-col :cols="8">
                  <div style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 1;-webkit-box-orient: vertical;color:#9e9e9e;">{{orderInfo.GZ_CONTENT}}</div>
                </v-col>
              </v-row>
            </v-list-item-subtitle>
            <v-list-item-subtitle style="margin-top:0.3rem;font-size:0.8rem;">
              <v-row no-gutters style="width:100%;">
                <v-col :cols="2" style="text-align:left;padding-left:0.06rem;">
                </v-col>
                <v-col :cols="8">
                  <i class="fa fa-clock-o" aria-hidden="true" style="color:#9E9E9E;" />
                  <span style="padding-left:0.3rem;color:#9e9e9e;" v-if="orderInfo.BIZ_SID === 4 || orderInfo.BIZ_SID === '4'">{{$moment(orderInfo.GZ_FINISH_TIME).format("YYYY年M月D日 HH:mm")}}</span>
                  <span style="padding-left:0.3rem;color:#9e9e9e;" v-else>{{$moment(orderInfo.ROW_DATE_CREATE).format("YYYY年M月D日 HH:mm")}}</span>
                  <span style="padding-left:0.3rem;color:#9e9e9e;" v-if="orderInfo.creator">
                    <span style="font-weight:bold;margin-left:0.5rem;margin-right:0.2rem;">·</span>
                    <span v-if="orderInfo.creator.USER_NAME">{{orderInfo.creator.USER_NAME}}</span>
                    <span v-else>{{orderInfo.creator.NICK_NAME}}</span>
                  </span>
                </v-col>
              </v-row>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

    </v-card>

</template>

<script>
import PriorityLabel from '../../components/PriorityLabelV2'
import GzBizSidLabel from '../../components/GzBizSidLabel'
export default {
  components: {
    PriorityLabel,
    GzBizSidLabel
  },
  props: {
    orderInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {

    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
  },
  methods: {
    goDetail() {
      this.$router.goPage('/OrderDetail/' + this.orderInfo.GZ_ORDER_CODE)
    }
  }
}
</script>

<style scoped>
</style>
